// src/types.ts
var FILE_DEFAULTS = "defaults.yml";
var FILE_ENVS = "envs-map.yml";
var FILE_DYNAMICS = "config.yml";

export {
  FILE_DEFAULTS,
  FILE_ENVS,
  FILE_DYNAMICS
};
//# sourceMappingURL=chunk-VQRJY4AQ.mjs.map
